export default {
  SET_ROLE_COURSE_PERMISSIONS(state, permissions) {
    state.roleCoursePermissions = permissions;
  }
};
